import { Box, type Breakpoint, type SxProps, type Theme, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import type { CSSProperties, FC, ReactNode } from "react";
import { BADGE, INK, INK_BLACK, STATUS, SURFACE } from "../../theme/tokens";

type Props = {
	label: ReactNode;
	subLabel?: ReactNode;
	leading?: ReactNode;
	trailing?: ReactNode;
	typographySx?: SxProps<Theme>;
	subTypographySx?: SxProps<Theme>;
	gap?: CSSProperties["gap"] | Partial<Record<Breakpoint, CSSProperties["gap"]>>;
	alignItems?: CSSProperties["alignItems"];
	showBadge?: string;
};
const defaultTypographySx = {
	fontWeight: 700,
	fontSize: { xl: "16px", lg: "14px", xs: "12px" },
	lineHeight: "30px",
	color: "primary.dark",
	textWrap: "nowrap",
} satisfies SxProps<Theme>;

const defaultSubLabelTypographySx = {
	fontWeight: 700,
	fontSize: "12px",
	lineHeight: "30px",
	color: alpha(INK.SECONDARY, 0.5),
	textWrap: "nowrap",
} satisfies SxProps<Theme>;

export const CommonDashboardHeader: FC<Props> = ({
	leading,
	trailing,
	label,
	subLabel,
	typographySx = defaultTypographySx,
	subTypographySx = defaultSubLabelTypographySx,
	alignItems = "center",
	gap = { xl: 2, xs: 0.25 },
	showBadge,
}) => {
	return (
		<Box
			sx={{
				display: "flex",
				justifyContent: "center",
				alignItems: alignItems,
				gap: gap,
			}}
		>
			{showBadge && (
				<div
					style={{
						backgroundColor: STATUS.ERROR.main,
						color: SURFACE,
						fontSize: "10px",
						fontWeight: "bold",
						padding: "2px 6px",
						borderRadius: `${BADGE.PILL_RADIUS_FULL}px`,
						textTransform: "uppercase",
						textAlign: "center",
						boxShadow: `0 2px 4px ${alpha(INK_BLACK, 0.2)}`,
					}}
				>
					{showBadge}
				</div>
			)}
			{leading}
			{typeof label === "string" ? <Typography sx={typographySx}>{label}</Typography> : label}
			{subLabel && (typeof subLabel === "string" ? <Typography sx={subTypographySx}>{subLabel}</Typography> : subLabel)}
			{trailing}
		</Box>
	);
};
